import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

// Actions
import { toggleSideNav, setPage, add_To_Recent_History, togglePostModal, goBack, toggleProfileModal } from '../../actions/navActions';
import { getSelectedGroupById } from '../../actions/groupActions';
import { getMatchById } from '../../actions/sportsMatchActions';
import { getProfileById } from '../../actions/authActions';

// Layout Wrapper
import Layout from '../../components/layout/Layout';

// components
import Spinner from '../../components/common/Spinner';
import TweetBox from '../../components/TweetBox/TweetBox';
import Post from '../../components/Post/Post';
import { Button } from '@material-ui/core';
import ProfileForm from '../../components/Profile/ProfileModal/ProfileForm';

// Icons - material UI
import CloseIcon from '@material-ui/icons/Close';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

// Modal
import ModalContainer from '../../components/modal/ModalContainer';
import Modal from '../../components/modal/Modal';
import BigModal from '../../components/modal/BigModal';

const CreatePost = ({ 
    setPage, 
    add_To_Recent_History,
    goBack,
    auth: { 
        profileUser 
    }, 
    post: { 
        post,
        postUploading,
        postUploadingImgs
    }, 
    togglePostModal, 
    toggleProfileModal,
    getSelectedGroupById,
    getMatchById,
    getProfileById,
    nav: { 
        postModal,
        profileModal,
        loading,
        page
    }, 
    history }) => {
    
    // State variable for tracking Mixpanel event
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // Modal toggles
    const [discardModal, setDiscardModal] = useState(false);
    const [postUploadingModal, setPostUploadingModal] = useState(false);
    const [postUploadingImgsModal, setPostUploadingImgsModal] = useState(false);

    // Window width state
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Extract URL and previous URL page
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    let previousUrl = url.searchParams.get("goBack");
    let groupId = url.searchParams.get("groupId");
    let sportId = url.searchParams.get("sportId");
    let profileId = url.searchParams.get("profileId");
    const hostname = window.location.hostname;

    useEffect(() => {

        // Event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());
        
        // Set current page to 'create'
        setPage('create');
        add_To_Recent_History(url.pathname);  // current url

        // Close post modal if open
        if(postModal) {
            togglePostModal();
        }

        // Clean up event listener
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    useEffect(() => {

        if(groupId) {
            getSelectedGroupById(groupId);
        }

    }, [groupId]);

    useEffect(() => {

        if(sportId) {
            getMatchById(sportId);
        }

    }, [sportId]);

    useEffect(() => {

        if(profileId) {
            getProfileById(profileId);
        }

    }, [profileId]);

    // Function to handle window size change
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Function to toggle discard modal
    const toggleDiscardModal = () => {
        setDiscardModal(!discardModal);
    }

    const togglePostUploadingModal = () => {
        setPostUploadingModal(!postUploadingModal);
    }

    const togglePostUploadingImgsModal = () => {
        setPostUploadingImgsModal(!postUploadingImgsModal);
    }

    // Logic for handling discard action
    const handleDiscard = () => {
        setDiscardModal(false);

        // Redirect to previous URL if available
        goBack();
        // if(previousUrl !== null) {
        //     window.location.href = `/${previousUrl}`;
        // } else {
        //     history.goBack()
        // }
    }

    // Check if the window size is mobile or tablet
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;

    // Redirect logic for non-mobile devices
    if(!isMobile) {
        if(previousUrl !== null) {
            togglePostModal();

            // Redirect based on previous URL
            if(previousUrl === 'detail') {
                if(post) {
                    history.push(`/post/${post._id}`);
                }
            } else if(previousUrl === 'group') {
                if(groupId) {
                    history.push(`/groups/${groupId}?show=posts`);
                }
            } else if(previousUrl === 'sport') {
                if(sportId) {
                    history.push(`/vs/${sportId}`);
                }
            } else if(previousUrl === 'profile') {
                if(profileUser || profileId) {
                    const temp_id = profileUser?._id || profileId;
                    history.push(`/user/${temp_id}${profileId ? '?show=reviews' : ''}`);
                } else {
                    history.push(`/home`);
                }
            } else {
                history.push(`/${previousUrl}`)
            }
        }
    }

    // Mixpanel tracking logic
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);
        mixpanel.track("Mobile Post Page View");
    }

    // Trigger Mixpanel tracking on first render
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {
        handleMixpanel();
        setSentMixpanel(true);
    }

    if(isMobile && profileModal && !loading && page !== 'set-up') {

        // If the user is on a mobile device, the profile modal is open,
        // the page is not in the loading state, and the page is not 'set-up',
        // redirect the user to the profile set-up page with a query parameter for navigation.
        if(previousUrl) {
            if(previousUrl === 'home') {
                history.push({
                    pathname: '/profile/set-up',
                    search: `?goBack=create_home`,
                })
            } else if(previousUrl === 'detail') {
                history.push({
                    pathname: '/profile/set-up',
                    search: `?goBack=create_detail`,
                })
            } else if(previousUrl === 'group') {
                history.push({
                    pathname: '/profile/set-up',
                    search: `?goBack=create_group${groupId && `?group=${groupId}`}`,
                })
            } else if(previousUrl === 'sport') {
                history.push({
                    pathname: '/profile/set-up',
                    search: `?goBack=create_sport${sportId && `?sport=${sportId}`}`,
                })
            } else if(previousUrl === 'profile') {
                history.push({
                    pathname: '/profile/set-up',
                    search: `?goBack=create_profile${profileId && `?profile=${profileId}`}`,
                })
            } else {
                history.push({
                    pathname: '/profile/set-up',
                    search: `?goBack=${previousUrl}`,
                })
            }
        } else {
            history.push({
                pathname: '/profile/set-up',
                search: `?goBack=home`,
            })
        }
    }

    return (
        <Fragment>
            <div className="createPost__page">
                {/* Post creation coomponents */}
                <div onClick={toggleDiscardModal} className="closeBtn__container start">
                    
                    {/* Button to go Back */}
                    <button  className="secondaryBtn close">
                        <ArrowBackIcon /> 
                        <span>Back</span>
                    </button>
                    {/* <Button className="tweetBox__tweetButton sliding">Tweet</Button> */}
                </div>

                {/* TweetBox */}
                <div style={{padding:'10px 10px 10px 20px'}}>
                    <TweetBox modal full_page show_btns history={history} goBackTo={previousUrl} isReview={!!profileId} />
                </div>
            </div>

            {/* Discard modal */}
            <ModalContainer show={discardModal} onClose={toggleDiscardModal}>
                <Modal>

                    {/* Title */}
                    <div>
                        <h2>Discard {!!profileId ? 'Review' : 'Post'}?</h2>
                    </div>

                    {/* Description */}
                    <p>Are you sure? Your draft will not be saved.</p>
                    
                    {/* Actions */}
                    <Button 
                        onClick={handleDiscard}
                        variant="outlined" 
                        className="sidebar__tweet black"
                        fullWidth
                    >
                        Discard
                    </Button>
                    <Button 
                        onClick={toggleDiscardModal}
                        variant="outlined" 
                        className="sidebar__tweet ghost blackText"
                        fullWidth
                    >
                        Keep Writing
                    </Button>
                </Modal>
            </ModalContainer>
            
            {/* Post is uploading Modal */}
            <ModalContainer show={postUploading} onClose={togglePostUploadingModal}>
                <Modal>

                    {/* Modal Title */}
                    <div>
                        <h2>Uploading Post...</h2>
                    </div>

                    {/* Modal Description */}
                    <p>Patience is a virtue.</p>
                    
                    <Spinner />
                </Modal>
            </ModalContainer>

            {/* Photos are uploading Modal */}
            <ModalContainer show={postUploadingImgs} onClose={togglePostUploadingImgsModal}>
                <Modal>

                    {/* Modal Title */}
                    <div>
                        <h2>Uploading Photos...</h2>
                    </div>

                    {/* Modal Description */}
                    <p>Patience is a virtue.</p>
                    
                    <Spinner />
                </Modal>
            </ModalContainer>

            {/* Sliding Set Up Profile Modal */}
            <ModalContainer show={profileModal} onClose={toggleProfileModal}>
                <BigModal>
                    <ProfileForm />
                </BigModal>
            </ModalContainer>
            
        </Fragment>
    )
}

CreatePost.propTypes = {
    toggleSideNav: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired,
    add_To_Recent_History: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    togglePostModal: PropTypes.func.isRequired,
    toggleProfileModal: PropTypes.func.isRequired,
    getSelectedGroupById: PropTypes.func.isRequired,
    getMatchById: PropTypes.func.isRequired,
    getProfileById: PropTypes.func.isRequired,
    post: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    post: state.post,
    nav: state.nav,
    auth: state.auth
});

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
    toggleSideNav, 
    setPage, 
    add_To_Recent_History,
    goBack,
    togglePostModal,
    toggleProfileModal,
    getSelectedGroupById,
    getMatchById,
    getProfileById
})(CreatePost);
